import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import axios from "axios";

import { ACCESS_TOKEN } from "./config/contentful";

import Navigation from "./components/Navigation";
import Header from "./components/Header";
import Homepage from "./components/Homepage";
import Section from "./components/Section";
import Contact from "./components/Contact";
import Footer from "./components/Footer";

const App = () => {
  const [sections, setSections] = useState([]);
  // const [assets, setAssets] = useState([]);

  useEffect(() => {
    axios(
      `https://cdn.contentful.com/spaces/bxj0nkc7h4nx/environments/master/entries?access_token=${ACCESS_TOKEN}&content_type=pageSection&select=fields.slug,fields.title,fields.description,fields.photos&order=fields.order`
    ).then((response) => {
      setSections(response.data.items);
      // setAssets(response.data.includes);
    });
  }, []);

  return (
    <>
      <Router>
        <Navigation sections={sections} />
        <Header />
        <Switch>
          {sections.map((section) => (
            <Route key={section.fields.slug} path={`/${section.fields.slug}`}>
              <Section {...section.fields} />
            </Route>
          ))}

          <Route path="/kontact">
            <Contact />
          </Route>

          <Route path="/">
            <Homepage sections={sections} />
          </Route>
        </Switch>
        <Footer />
      </Router>
    </>
  );
};

export default App;
